import { BASE_URL } from '@/constants/seo';
export const blogsSeo = {
  title: 'Health & Wellness Blog | LIPS Healthcare London',
  metaTitle:
    'Health & Wellness Blog | Expert Medical Insights | LIPS Healthcare',
  metaDescription:
    "Explore expert health articles, medical insights, and wellness tips from LIPS Healthcare's specialist consultants in London. Stay informed about treatments, conditions, and care.",
  keywords: [
    'lips healthcare blog',
    'health and wellness blog london',
    'medical insights london',
    'private healthcare articles london',
    'specialist health advice london',
    'orthopaedic blog london',
    'healthcare tips london',
    'medical conditions treatment blog',
    'consultant surgeon advice',
    'lips healthcare news',
  ],
  canonical: `${BASE_URL}/blogs`,
  robots: {
    index: true,
    follow: true,
    nocache: false,
  },
  openGraph: {
    title: 'Health & Wellness Blog | LIPS Healthcare London',
    description:
      "Expert health articles and medical insights from LIPS Healthcare's specialist consultants in London. Covering orthopaedics, wellness, treatments, and more.",
    url: `${BASE_URL}/blogs`,
    siteName: 'LIPS Healthcare',
    locale: 'en_GB',
    type: 'website',
  },
  twitter: {
    card: 'summary_large_image',
    title: 'Health & Wellness Blog | LIPS Healthcare London',
    description:
      "Expert health articles and medical insights from LIPS Healthcare's specialist consultants in London.",
  },
};
